<template>
  <div>
    <!-- <div class="bg-white m-3 rounded-md">
      <div
        class="flex flex-wrap justify-center lg:gap-24 gap-10 relative lg:p-6 p-3"
      >
        <div v-for="(tab, index) in tabs" :key="index">
          <img
            @click="changeTab(tab.name)"
            class="h-10 border border-primary border-1.5 rounded-full mx-auto p-2 cursor-pointer transform hover:scale-105"
            :src="selectedTab == tab.name ? tab.icon : tab.icon_p"
            :class="{
              'bg-primary': selectedTab == tab.name,
            }"
          />
          <p class="text-sm font-semibold pt-2">{{ tab.name }}</p>
        </div>
      </div>
    </div> -->
    <div>
      <ObjHome :key="objkey" v-if="selectedTab == 'Objectives'"></ObjHome>
      <MyRevHome :key="mykey" v-if="selectedTab == 'My Reviews'"></MyRevHome>
      <ManagerReviewHome
        :key="mgrkey"
        v-if="selectedTab == 'Manager Review'"
      ></ManagerReviewHome>
      <AgreedHome :key="agrdkey" v-if="selectedTab == 'Agreed'"></AgreedHome>
      <RecommendationHome
        :key="Reckey"
        v-if="selectedTab == 'Recommendation'"
      ></RecommendationHome>
    </div>
  </div>
</template>
<script>
import ObjHome from "./objectives/ObjHome.vue";
import MyRevHome from "./myreviews/myRevHome.vue";
import ManagerReviewHome from "./managerReview/managerReviewHome.vue";
import AgreedHome from "./agreed/agreedHome.vue";
import RecommendationHome from "./recommendation/recommendationHome.vue";
export default {
  name: "SinglePerformanceFlow",
  components: {
    ObjHome,
    MyRevHome,
    ManagerReviewHome,
    AgreedHome,
    RecommendationHome,
  },
  data() {
    return {
      selectedTab: "Objectives",
      objkey: 0,
      mykey: 1,
      mgrkey: 2,
      agrdkey: 3,
      Reckey: 4,
      tabs: [
        {
          name: "Objectives",
          icon_p: require("@/assets/icons/star_p.png"),
          icon: require("@/assets/icons/star.png"),
        },
        {
          name: "My Reviews",
          icon_p: require("@/assets/icons/comment_p.png"),
          icon: require("@/assets/icons/comment.png"),
        },
        {
          name: "Manager Review",
          icon_p: require("@/assets/icons/comments_p.png"),
          icon: require("@/assets/icons/comments.png"),
        },
        {
          name: "Agreed",
          icon_p: require("@/assets/icons/handshake_p.png"),
          icon: require("@/assets/icons/handshake.png"),
        },
        {
          name: "Recommendation",
          icon_p: require("@/assets/icons/like_p.png"),
          icon: require("@/assets/icons/like.png"),
        },
      ],
    };
  },
  methods: {
    changeTab(tab) {
      this.selectedTab = tab;
      switch (this.selectedTab) {
        case "Objectives":
          this.objkey++;
          break;
        case "My Reviews":
          this.mykey++;
          break;
        case "Manager Review":
          this.mgrkey++;
          break;
        case "Agreed":
          this.agrdkey++;
          break;
        case "Recommendation":
          this.Reckey++;
          break;
      }
    },
  },
};
</script>
